import type { Distance, Point } from "@pdfking/math"
import type { ColorID, PlotPath } from "@pdfking/renderer-api"
import { DrawPath, PlotFunction } from "@pdfking/renderer-api"

export const CreatePath = (
  points: Point<Distance>[],
  stroke_color: ColorID,
  opts: Partial<PlotPath> = {}
) => ({
  enum: PlotFunction.PLOT_PATH as const,
  points: DrawPath(points),
  stroke_color,
  ...opts,
})
